// extracted by mini-css-extract-plugin
module.exports = {"daysBold":"ReturnDaysText_daysBold__TrZ5C","text":"ReturnDaysText_text__fe01N","modalText":"ReturnDaysText_modalText__E0SRK"};